import type { ServicesApiAllDeliveriesMetric } from '@/services/api/services-api';

/**
 * Normalize legacy timezone values stored in the DB to valid IANA timezones.
 * The Ember app has the same mapping — "Eastern" is a legacy value that
 * predates proper IANA timezone storage.
 */
export function normalizeTimezone(timezone: string): string {
  if (timezone === 'Eastern') return 'Etc/GMT+4';
  return timezone;
}

/**
 * Aggregates delivery metrics across all channels into daily totals.
 */
export function aggregateMetrics(metrics: ServicesApiAllDeliveriesMetric[], timezone?: string) {
  if (metrics.length === 0) return { sent: [], delivered: [], opened: [], categories: [] };

  const length = metrics[0].values.sent.length;
  const sent = new Array<number>(length).fill(0);
  const delivered = new Array<number>(length).fill(0);
  const opened = new Array<number>(length).fill(0);

  for (const metric of metrics) {
    for (let index = 0; index < length; index++) {
      sent[index] += metric.values.sent[index];
      delivered[index] += metric.values.delivered[index];
      opened[index] += metric.values.human_opened[index];
    }
  }

  const now = new Date();
  const dateFormatOptions: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
  if (timezone != null) {
    dateFormatOptions.timeZone = timezone;
  }
  const categories: string[] = [];
  for (let index = length - 1; index >= 0; index--) {
    const date = new Date(now.getTime() - index * 86400 * 1000);
    categories.push(date.toLocaleDateString('en-US', dateFormatOptions));
  }

  return { sent, delivered, opened, categories };
}
